import { render } from "./TableView.vue?vue&type=template&id=ce249a9e"
import script from "./TableView.vue?vue&type=script&lang=js"
export * from "./TableView.vue?vue&type=script&lang=js"

import "./TableView.vue?vue&type=style&index=0&id=ce249a9e&lang=css"

import exportComponent from "/builds/intern/postcollect-portal-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__